/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { TUMPeriodDay, TUMPeriodDay$inboundSchema } from "./tumperiodday.js";

export type TUMPeriod = {
  /**
   * Daily breakdown of TUM within the cycle. Days without usage are omitted.
   */
  days: Array<TUMPeriodDay>;
  /**
   * End of the billing cycle (exclusive)
   */
  periodEnd: Date;
  /**
   * Start of the billing cycle
   */
  periodStart: Date;
  /**
   * Tokens under management consumed during the cycle
   */
  tokens: number;
};

/** @internal */
export const TUMPeriod$inboundSchema: z.ZodMiniType<TUMPeriod, unknown> = z
  .pipe(
    z.object({
      days: z.array(TUMPeriodDay$inboundSchema),
      period_end: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      period_start: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      tokens: z.int(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "period_end": "periodEnd",
        "period_start": "periodStart",
      });
    }),
  );

export function tumPeriodFromJSON(
  jsonString: string,
): SafeParseResult<TUMPeriod, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TUMPeriod$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TUMPeriod' from JSON`,
  );
}
